module.exports = __webpack_public_path__ + "img/asset17x1.a21926c5.png";